var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrajavaniAfterLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 88,
    height: 88,
    rx: 44,
    fill: "#FFF0D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 88,
    height: 88,
    rx: 44,
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.9993 50.2122C51.4553 49.8607 49.7675 49.667 47.9993 49.667C40.6355 49.667 34.666 53.0248 34.666 57.167C34.666 61.3092 34.666 64.667 47.9993 64.667C57.4783 64.667 60.2185 62.9698 61.0107 60.5003",
    stroke: "#1C274C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0007 60.3333C62.6825 60.3333 65.6673 57.3486 65.6673 53.6667C65.6673 49.9848 62.6825 47 59.0007 47C55.3188 47 52.334 49.9848 52.334 53.6667C52.334 57.3486 55.3188 60.3333 59.0007 60.3333Z",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7773 53.667L58.1665 55.3337L61.2218 52.1855",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0007 44.6663C51.6825 44.6663 54.6673 41.6816 54.6673 37.9997C54.6673 34.3178 51.6825 31.333 48.0007 31.333C44.3188 31.333 41.334 34.3178 41.334 37.9997C41.334 41.6816 44.3188 44.6663 48.0007 44.6663Z",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrajavaniAfterLogin);
export default __webpack_public_path__ + "static/media/prajavani-after-login.cd9c96f053b04d1227dcedd6e9cb217f.svg";
export { ForwardRef as ReactComponent };